export default __webpack_public_path__ + "static/media/logo.30641816.png";